import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import './TextEditor.css';

type Props = {
  editorState: EditorState;
  onEditorStateChange: (editorState: EditorState) => void;
  placeholder?: string;
  readOnly?: boolean;
};

const TextEditor: React.FC<Props> = ({ editorState, onEditorStateChange, readOnly }) => {
  return (
    <Editor
      editorState={editorState}
      onEditorStateChange={onEditorStateChange}
      readOnly={readOnly}
    />
  );
};

export default TextEditor;
